export const SuccessIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="32" fill="#10B981" fillOpacity="0.1" />
    <path d="M44 24L28 40L20 32" stroke="#10B981" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ErrorIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="32" fill="#EF4444" fillOpacity="0.1" />
    <path d="M32 20V36M32 44V44.02" stroke="#EF4444" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CancelIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="32" fill="#F59E0B" fillOpacity="0.1" />
    <path d="M24 24L40 40M40 24L24 40" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const PendingIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="32" fill="#3B82F6" fillOpacity="0.1" />
    <circle cx="32" cy="32" r="16" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round" />
    <path d="M32 24V32L38 38" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
